const SlideDefaultProps = {
  className: undefined,
  contentTopBiases: undefined,
  image: null,
  isDark: { mobile: false, desktop: false },
  isVideoLooping: false,
  overlayImage: undefined,
  video: null,
  videoCurrentTime: 0,
  ctaHeader: undefined,
  replaceTitleWithVectorImage: false,
  audioButtonPosition: undefined,
  contentType: undefined,
};

export default SlideDefaultProps;
